<template>
    <div>
      <div class="uk-section">
        <div class="uk-grid-small" uk-grid>
          <div class="uk-width-1-1">
            <h2 class="uk-text-center">.commodity installation</h2>
          </div>
          <div class="uk-width-1-1@s uk-width-1-1@m uk-width-1-2@l uk-width-1-2@l uk-align-center">
            <form class="uk-form-horizontal" v-on:submit.prevent="install">
              <fieldset class="uk-fieldset">
                <legend class="uk-legend">System settings</legend>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="base_url" class="uk-form-label">Base url</label>
                    <div class="uk-form-controls">
                      <input id="base_url" type="text" v-model="base_url" class="uk-input" placeholder="Enter the base url" required>
                    </div>
                  </div>
                  <div class="uk-inline">
                    <label for="force_https" class="uk-form-label">Force https</label>
                    <div class="uk-form-controls">
                      <div class="uk-inline">
                        <input id="force_https" type="checkbox" class="uk-checkbox" v-model="force_https" value="true">
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset class="uk-fieldset">
                <legend class="uk-legend">Database settings</legend>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="db_hostname" class="uk-form-label">Hostname</label>
                    <div class="uk-form-controls">
                      <input id="db_hostname" type="text" v-model="database.host" class="uk-input" placeholder="Enter the hostname" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="db_user" class="uk-form-label">User</label>
                    <div class="uk-form-controls">
                      <input id="db_user" type="text" v-model="database.username" class="uk-input" placeholder="Enter the username" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="db_password" class="uk-form-label">Password</label>
                    <div class="uk-form-controls">
                      <input id="db_password" type="text" v-model="database.password" class="uk-input" placeholder="Enter the password" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="db_name" class="uk-form-label">DB Name</label>
                    <div class="uk-form-controls">
                      <input id="db_name" type="text" v-model="database.name" class="uk-input" placeholder="Enter the name" required>
                    </div>
                  </div>
                </div>
              </fieldset>
              <fieldset class="uk-fieldset">
                <legend class="uk-legend">User settings</legend>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="email" class="uk-form-label">Email</label>
                    <div class="uk-form-controls">
                      <input id="email" type="email" v-model="user.email" class="uk-input" placeholder="Enter the email" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="password" class="uk-form-label">Password</label>
                    <div class="uk-form-controls">
                      <input id="password" type="text" v-model="user.password" class="uk-input" placeholder="Enter the password" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="given_name" class="uk-form-label">Given name</label>
                    <div class="uk-form-controls">
                      <input id="given_name" type="text" v-model="user.given_name" class="uk-input" placeholder="Enter the given name" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin">
                  <div class="uk-inline">
                    <label for="family_name" class="uk-form-label">Family name</label>
                    <div class="uk-form-controls">
                      <input id="family_name" type="text" v-model="user.family_name" class="uk-input" placeholder="Enter the family name" required>
                    </div>
                  </div>
                </div>
                <div class="uk-margin uk-text-center">
                  <div class="uk-inline">
                    <button v-if="state" class="uk-button uk-button-primary" >Install</button>
                  </div>
                </div>
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
  export default {
    name: "Install",
    data() {
      return {
        state: true,
        base_url: null,
        force_https: false,
        database: {
          host: null,
          username: null,
          password: null,
          name: null
        },
        user: {
          email: null,
          password: null,
          given_name: null,
          family_name: null,
        }
      }
    },
    methods: {
      install() {
        const self = this;

        self.state = false;

        self.$request().post('/status/install', {
          base_url: self.base_url,
          force_https: self.force_https,
          db_host: self.database.host,
          db_name: self.database.name,
          db_user: self.database.username,
          db_pass: self.database.password,
          email: self.user.email,
          given_name: self.user.given_name,
          family_name: self.user.family_name,
          password: self.user.password
        }).then(r => {
          self.$uikit().notification({
            message: 'Installation completed successfully.',
            status: 'success',
            position: 'top-center',
            timeout: 3000,
          });
          self.$router.push({name: 'Home'});
        }).catch(e => {
          self.$uikit().notification({
            message: 'Something went wrong! Please try again later.',
            status: 'danger',
            position: 'top-center',
            timeout: 3000,
          });
        });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Install.vue